<script>
		import { user, game, view, send_request} from "../client.svelte.js";
		import {Implics, timestamp, token_URL} from "../core.js";
		import {fly, fade} from "svelte/transition";

    let { info } = $props();
		let type = $derived(info.ZUB?.slice(0,8) ?? "Info")
		let activity = $derived(game.activities.get(info.sender) ?? {})
		let subject = $derived(game.personas.get(info.subject))
    let portraitURL = $derived((game.personas.has(info.subject)) ? game.personas.get(info.subject).tokenURL : "assets/tokens/Master.png")
		let target = $derived((info.ZUB?.slice(0,8) === 'Instruct') ? game.personas.get(info.subject) : game.personas.get(info.target))
		let descriptIncid = $derived(game.infos.get(info.sender+0.01) ?? info)
		let description = $derived((descriptIncid.text) ? descriptIncid.text : activity.descript ?? "")
    let chance = $derived((user.isMaster && info.rolled && info.acttype !== 'Performance') ? info.rolled.split("||")[0] : "")
    let result = $derived((((user.isMaster) ? info.result : info.result?.replaceAll(regEx, "")) ?? activity.result))
    let editable = $derived(user.isMaster || game.playables.includes(info.subject))
    let subordinateds = $derived((info.subords) ? info.subords.map(inflID => game.infos.get(inflID)).filter(Boolean) : [])
    let rolled
    const regEx = new RegExp("\\[.*?\\]", 'g')  // finds paranthesis (round brackets)

    // $inspect("OCCURRED - info", info, activity)

		const achievGrades = "O: laienhaft (≥ 0)\nI: sachkundig (≥ 5)\nII: kompetent (≥ 10)\nIII: professionell (≥ 15)\nIV: meisterhaft (≥ 20)\nV: legendär (≥ 25)"

		function enter_caption(e) {
				const selection = window.getSelection();
				const range = document.createRange();
				range.selectNodeContents(this);
				selection.removeAllRanges();
				selection.addRange(range);
		}

		function capture_enter(e) {
				if (e.key === 'Enter') {
					  e.target.blur()
						e.preventDefault() }
		}

		function change_descript(e) {
				const newDescript = e.target.textContent.trim()
				document.getSelection().removeAllRanges()
				if (newDescript === description) return
				send_request('alter', {action: 'DESCRIBE', incidID: descriptIncid.ID, text: newDescript}, "Change description of occurred")		}
</script>


<!-------------------------------- HTML -------------------------------------->

<div class="incident {type}" class:current={view.persona?.ID === info.subject}
		 out:fly={{x: '100%', duration: 1000}} >
	<div class=tick-time title={info.ID}>{timestamp(info.time + (info?.cont ?? 0))}</div>
	<!-- portrait of causer	-->
	{#if !['Info', 'Instruct', 'Incurren'].includes(type) && subject}
		<figure class="icon subject" onclick={() => view.select_persona(subject)}>
	        <img src={portraitURL} alt={subject.ID}>
	        <figcaption>{subject.ID ?? ''}</figcaption>
		</figure>
	{/if}
	<!-- text of incident -->
	<span class="{(!info.ZUB) ? 'only' : 'tickDouble'}" class:shout={info.action === 'Ruf'} title="{info.action ?? ''} {chance}"
          contenteditable={editable} onfocus={enter_caption} onkeydown={capture_enter} onblur={change_descript}>
		{#if !info.ZUB && info.subject}{info.subject}: {/if}
			{description}
	</span>
	<!-- portrait of target (if caused by game/master)	-->
	{#if type === 'Instruct' && target}
		<figure class="icon target" onclick={() => view.select_persona(target)}>
	        <img src={target.tokenURL} alt={target.ID}>
	        <figcaption>{target.ID ?? ''}</figcaption>
		</figure>
	{/if}
	<!-- MASTER: action, roll and success -->
	{#if user.isMaster && info.action && info.action !== 'Meinung'}
        <div class=tick-double>{info.action + ": " + info.rolled}</div>
	{/if}
	<!-- result -->
	{#if type !== 'Instruct'}
		<div class=tick-double title={rolled ?? (info.ZUB === 'Insight') ? achievGrades : null}>{result ?? ''}</div>
	{/if}
	<!-- indirect incidents -->
	{#if subordinateds.length > 0}
	  {#each subordinateds as infl (infl.ID)}
			<div class=inferior title={infl.ID}>{infl.text}</div>
	  {/each}
	{/if}

</div>


<!-------------------------------- STYLES -------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	.incident
		margin: 12px 6px
		display: grid
		grid-gap: 5px
		grid-template-columns: 4ch 48px auto
		color: black

	.incident.Instruct, .incident.Induce
		grid-template-columns: 4ch auto 48px

	.tick-time
		grid-column: 1
		justify-self: center

	.tick-double
		grid-column: 3 / span 2

	.subject
		display: inline-block
		position: relative
		grid-column: 2
		grid-row: span 3

	.target
		display: inline-block
		position: relative
		grid-column: 3
		grid-row: span 3

	//.target img
	//	width: 32px
	//	height: 32px

	.incident .shout
		font-weight: bold

	.incident.current
		font-weight: bold

	.incident .only
		grid-column: 2 / span 3

	.inferior
		grid-column: 3 / span 2

</style>